var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"button copy",attrs:{"role":"button"}},[_c('span',{staticClass:"tip"},[_vm._v("別のノートに複製")]),_c('FontawesomeIcon',{staticClass:"icn",attrs:{"icon":['fal','copy']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }